export const offeringCards = [
  {
    icon: "ri-film-line",
    title: "老电影片库",
    desc: "按年代与类型整理的老片索引，覆盖从八十年代到九十年代末的常见作品，方便按线索逐步查找。",
    points: ["按年代检索", "按类型归类", "标注片长与主创"],
  },
  {
    icon: "ri-movie-2-line",
    title: "经典港片",
    desc: "集中整理武侠、警匪、喜剧与文艺等方向的港片，帮助区分不同类型之间的风格差异。",
    points: ["动作与警匪", "古装与武侠", "都市喜剧"],
  },
  {
    icon: "ri-time-line",
    title: "九十年代电影",
    desc: "以年表方式梳理九十年代的电影脉络，标出每一年的代表作品与题材走向。",
    points: ["逐年梳理", "题材趋势", "代表作品"],
  },
  {
    icon: "ri-tv-2-line",
    title: "老片在线与怀旧剧场",
    desc: "汇总老片在线的观看思路与怀旧剧场的排片安排，帮助安排一次有节奏的观影计划。",
    points: ["版本与画质提示", "排片参考", "观看顺序建议"],
  },
];

export const watchSteps = [
  {
    icon: "ri-search-eye-line",
    step: "01",
    title: "先确定主题方向",
    desc: "想看的究竟是武侠、警匪还是都市爱情，先锁定一个方向，再进入对应类型的片单，比漫无目的地翻找更高效。",
  },
  {
    icon: "ri-list-check-2",
    step: "02",
    title: "对照年代与片长",
    desc: "老片时长从八十多分钟到两小时以上不等，安排观看时先看片长，避免一次排太多而看不完。",
  },
  {
    icon: "ri-hd-line",
    step: "03",
    title: "留意版本与画质",
    desc: "同一部老片常有修复版与旧版之分，画面比例、字幕与配音可能不同，观看前先确认版本，体验差别很大。",
  },
  {
    icon: "ri-calendar-schedule-line",
    step: "04",
    title: "按排片规划顺序",
    desc: "如果想系统回顾九十年代，可以依照怀旧剧场的时间线，从早到晚按年份推进，脉络会更清楚。",
  },
];

export const watchTips = [
  "老片画质受当年胶片条件限制，出现轻微颗粒感属正常现象，不必因此判定为损坏。",
  "部分老片存在国语与粤语两种配音，剧情一致但语气不同，可依个人习惯选择。",
  "年代较早的作品常使用当时的用语与梗，结合时代背景理解会更顺畅。",
  "同一系列作品建议按上映年份观看，人物关系与设定通常更连贯。",
  "若以怀旧剧场为主，先看片单再定时间，连看多场时留意中间留出休息。",
];

export const statsList = [
  { value: "1986", label: "片库最早年份", desc: "本页收录作品的起始年份" },
  { value: "12", label: "代表影片", desc: "按类型与年代精选的条目" },
  { value: "10", label: "九十年代年表", desc: "1990 至 1999 逐年梳理" },
  { value: "8", label: "类型标签", desc: "武侠、警匪、喜剧、文艺等" },
];

export const decadeBars = [
  { label: "八十年代", percent: 42, note: "枪战与古装奇幻起步" },
  { label: "九十年代", percent: 88, note: "类型最丰富的高峰期" },
  { label: "都市文艺", percent: 58, note: "情感与作者风格并进" },
  { label: "古装武侠", percent: 70, note: "旧题材的新表达" },
  { label: "市井喜剧", percent: 64, note: "贴近生活的娱乐片" },
];

export const glossaryList = [
  { term: "片库", meaning: "指按一定规则整理、可被检索的老片集合，通常按年代或类型归档。" },
  { term: "修复版", meaning: "对老胶片进行画面与声音处理的版本，通常比旧版更清晰，但画面比例可能调整。" },
  { term: "胶片颗粒", meaning: "老旧胶片固有的细密颗粒，是年代质感的一部分，不等于画质损坏。" },
  { term: "双配音", meaning: "同一部影片存在国语与粤语等不同配音版本，剧情相同、语气不同。" },
  { term: "怀旧剧场", meaning: "以年代老片为主要放映内容的主题性排片栏目，强调时代氛围。" },
  { term: "年表", meaning: "按年份排列的作品与事件列表，用来观察一个时期题材走向的变化。" },
];

export const faqList = [
  {
    q: "九七电影院主要整理哪些内容？",
    a: "这里面向怀旧老片片库的需求，整理了老电影、怀旧片、经典港片与九十年代电影，并补充老片在线与怀旧剧场两个方向，方便从不同角度核对与查找。",
  },
  {
    q: "页面上的影片信息可以直接当作完整资料吗？",
    a: "页面内容以整理与导览为主，影片条目、年份与主创为常见公开信息，用于帮助建立整体印象。若需要更精确的版本、时长或发行资料，建议再对照权威片源或正式资料核实。",
  },
  {
    q: "观看老片时需要注意什么？",
    a: "建议先确认版本与画质，并留意配音语言；老片画质受年代限制，出现颗粒感属正常现象。若按年表系统回顾，可从年份较早的作品依序看起。",
  },
  {
    q: "怀旧剧场的排片是固定的吗？",
    a: "本页排片为示例性质的导览安排，用于说明一天内可以怎样组合不同年代与类型的作品。实际观看计划可根据自己的时间与偏好调整。",
  },
  {
    q: "筛选和搜索功能是怎么工作的？",
    a: "类型标签与关键词搜索都只作用于本页已经呈现的影片条目，不会连接外部数据或加载新内容，方便你在现有条目中快速定位。",
  },
];